var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuzzleSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.353,
    height: 117.613,
    viewBox: "0 0 136.353 117.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80426",
    "data-name": "Group 80426",
    transform: "translate(-112.048 -195.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111237",
    "data-name": "Path 111237",
    d: "M28.444,27.814a46.793,46.793,0,0,0,14.5,2.575c7.278-.077,15.8-4.706,15.858-7.436s-8.483-8.83-2.589-15.977S68.719-1.971,74.434,2.245s6.979,10.394,5.356,14.242-5.312,8.277-3.387,9.831,4.672,3.9,16.582,3.2c14.524-.858,12.992-2.21,13.593-.931s-5.264,21.747-4.361,25.253,5.793,4.691,7.838,3.961,6.852-6.985,12.086-3.157,4.68,9.6,3.826,16.546c-1.021,8.3-8.772,8.817-12.884,5.5-6.256-5.05-9.684-1.865-10.285.03s-1.44,19.32,3.854,23.592-.841,6.463-.841,6.463-30.769,1.342-34.767-3.462c-2.328-2.8-1.154-8.712,1.992-10.084C77.024,91.489,77,86.572,74.39,81.375c-2.347-4.671-8.247-6.459-14.627-3.634C48.5,82.73,52.706,91.4,56.924,93.612c4.236,2.218,2.449,7.572.705,10.529s-33.142,2.214-33.2-1.406,7.155-13.666,7.154-20.015.658-13.652-.845-15.759a4.355,4.355,0,0,0-6.857.02c-2.225,2.569-1.383,5.629-8.661,5.706-3.006.032-16.207-3.228-15.16-17,1.08-14.205,16.115-14.811,19.968-10.864,5.474,5.609,5.776,8.894,8.963,7.1s-.243-12.363-2.168-17.092-1.625-5.676,1.623-7.022",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 115.156, 203.484)",
    fill: "#ffb92e",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110255",
    "data-name": "Path 110255",
    d: "M27.244,26.64a44.817,44.817,0,0,0,13.884,2.466c6.971-.074,15.131-4.508,15.189-7.122s-8.124-8.458-2.48-15.3S65.818-1.888,71.292,2.15s6.684,9.956,5.13,13.641-5.087,7.928-3.244,9.416,4.475,3.739,15.882,3.065c13.911-.822,12.443-2.117,13.02-.892S97.037,48.209,97.9,51.567s5.548,4.493,7.507,3.794,6.563-6.69,11.576-3.024,4.482,9.2,3.664,15.848c-.978,7.951-8.4,8.445-12.34,5.266-5.992-4.836-9.275-1.786-9.851.029s-1.379,18.5,3.691,22.6-.806,6.19-.806,6.19-29.47,1.285-33.3-3.316c-2.23-2.68-1.106-8.344,1.908-9.658,3.82-1.666,3.8-6.374,1.3-11.352-2.248-4.474-7.9-6.187-14.009-3.481-10.789,4.778-6.76,13.085-2.719,15.2,4.057,2.124,2.346,7.253.676,10.085S23.455,101.866,23.4,98.4s6.853-13.089,6.852-19.171.63-13.075-.809-15.094a4.171,4.171,0,0,0-6.568.019c-2.131,2.46-1.324,5.392-8.295,5.466C11.7,69.649-.946,66.527.056,53.339,1.091,39.733,15.491,39.153,19.181,42.934c5.243,5.372,5.532,8.519,8.585,6.8s-.232-11.842-2.077-16.37-1.556-5.436,1.554-6.726",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 117.903, 205.646)",
    fill: "#ffb92e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110256",
    "data-name": "Path 110256",
    d: "M479.689,236.379a8.814,8.814,0,1,1-8.814-8.814,8.814,8.814,0,0,1,8.814,8.814",
    transform: "translate(-272.522 10.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110257",
    "data-name": "Path 110257",
    d: "M287.993,236.379a8.814,8.814,0,1,1-8.814-8.814,8.814,8.814,0,0,1,8.814,8.814",
    transform: "translate(-109.82 10.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110258",
    "data-name": "Path 110258",
    d: "M292.291,238.788a8.812,8.812,0,0,1-12.584,11.923,8.813,8.813,0,1,0,12.584-11.923",
    transform: "translate(-117.748 0.829)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110259",
    "data-name": "Path 110259",
    d: "M483.987,238.788A8.812,8.812,0,0,1,471.4,250.711a8.813,8.813,0,1,0,12.584-11.923",
    transform: "translate(-280.45 0.829)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110260",
    "data-name": "Path 110260",
    d: "M276.908,243.326a9.218,9.218,0,1,1,9.219-9.218,9.229,9.229,0,0,1-9.219,9.218m0-17.627a8.409,8.409,0,1,0,8.409,8.409,8.418,8.418,0,0,0-8.409-8.409",
    transform: "translate(-107.549 12.626)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110261",
    "data-name": "Path 110261",
    d: "M309.029,288.044a4.27,4.27,0,1,1-4.27-4.27,4.27,4.27,0,0,1,4.27,4.27",
    transform: "translate(-135.387 -37.353)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110262",
    "data-name": "Path 110262",
    d: "M322.729,309.075a1.748,1.748,0,1,1-1.747-1.748,1.747,1.747,0,0,1,1.747,1.748",
    transform: "translate(-149.613 -57.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110263",
    "data-name": "Path 110263",
    d: "M468.6,243.326a9.218,9.218,0,1,1,9.219-9.218,9.229,9.229,0,0,1-9.219,9.218m0-17.627a8.409,8.409,0,1,0,8.409,8.409A8.418,8.418,0,0,0,468.6,225.7",
    transform: "translate(-270.251 12.626)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110264",
    "data-name": "Path 110264",
    d: "M500.643,288.044a4.27,4.27,0,1,1-4.27-4.27,4.27,4.27,0,0,1,4.27,4.27",
    transform: "translate(-298.019 -37.353)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110265",
    "data-name": "Path 110265",
    d: "M515.343,309.075a1.748,1.748,0,1,1-1.747-1.748,1.747,1.747,0,0,1,1.747,1.748",
    transform: "translate(-313.494 -57.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110266",
    "data-name": "Path 110266",
    d: "M240.856,125.994c1.463,1.037,1.911-1.588,5.271-3.194,2.8-1.339,5.007-.308,5.248-1.551s-2.49-2.227-6.67-.485c-3.111,1.3-5.548,4.026-3.849,5.23",
    transform: "translate(-85.298 102.703)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110267",
    "data-name": "Path 110267",
    d: "M11.386,6.476C9.831,7.591,9.31,4.808,5.677,3.135,2.648,1.741.3,2.856.018,1.539S2.657-.851,7.172.96c3.36,1.347,6.019,4.222,4.214,5.516",
    transform: "translate(197.884 221.281) rotate(-3)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110268",
    "data-name": "Path 110268",
    d: "M357.262,386.811a.578.578,0,0,0-.494.277,12.4,12.4,0,0,1-2.875,2.952,17.124,17.124,0,0,1-9.451,3.336c-8.708.523-13.913-6.266-13.965-6.335a.578.578,0,0,0-.925.695,18.2,18.2,0,0,0,3.945,3.616,17.505,17.505,0,0,0,11.013,3.179,18.261,18.261,0,0,0,10.128-3.605,13.241,13.241,0,0,0,3.116-3.236.578.578,0,0,0-.493-.879",
    transform: "translate(-159.956 -121.608)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110269",
    "data-name": "Path 110269",
    d: "M.819.136A5.538,5.538,0,0,0,.4,5.1a.3.3,0,0,0,.356.2.291.291,0,0,0,.2-.356A4.994,4.994,0,0,1,1.318.428c.2-.317-.3-.608-.5-.292",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 168.375, 261.458)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110270",
    "data-name": "Path 110270",
    d: "M.08.492a4.471,4.471,0,0,1,.972,4.2.266.266,0,1,0,.51.154A5.091,5.091,0,0,0,.454.083C.209-.176-.165.232.08.492",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 198.354, 261.648)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19654",
    "data-name": "Rectangle 19654",
    width: 121.177,
    height: 102.431,
    transform: "translate(119.654 203.5)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleSmile);
export default __webpack_public_path__ + "static/media/puzzle_smile.b76e7c3ffd0a1c3c2a894a68abd2c765.svg";
export { ForwardRef as ReactComponent };